/* d.nuvo duo bundles: live total, add both products (+ optional add-ons) to the cart. */
(function () {
  function init(root) {
    if (root.__duo) return;
    root.__duo = true;
    var currency = root.getAttribute('data-currency') || 'SGD';
    var code = root.getAttribute('data-discount-code') || '';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
    catch (e) { fmt = { format: function (n) { return currency + ' ' + Math.round(n); } }; }

    root.querySelectorAll('[data-duo-card]').forEach(function (card) {
      var totalEl = card.querySelector('[data-duo-total]');
      var btn = card.querySelector('[data-duo-add]');
      var statusEl = card.querySelector('[data-duo-status]');
      var base = parseInt(card.getAttribute('data-base'), 10) || 0;

      function addons() { return Array.prototype.filter.call(card.querySelectorAll('[data-duo-addon]'), function (c) { return c.checked; }); }
      function recalc() {
        var sum = base;
        addons().forEach(function (c) { sum += parseInt(c.getAttribute('data-price'), 10) || 0; });
        if (totalEl) totalEl.textContent = fmt.format(sum / 100);
      }
      card.querySelectorAll('[data-duo-addon]').forEach(function (c) { c.addEventListener('change', recalc); });

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var name = card.getAttribute('data-name');
        var items = [
          { id: parseInt(card.getAttribute('data-hero-id'), 10), quantity: 1, properties: { 'Duo': name } },
          { id: parseInt(card.getAttribute('data-partner-id'), 10), quantity: 1, properties: { 'Duo': name } }
        ];
        addons().forEach(function (c) { items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 }); });
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…'; statusEl.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        }).then(function () {
          // Apply the optional discount code for this browser session, then open the bag.
          var applied = code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
          return applied;
        }).then(function () {
          btn.textContent = 'Added ✓';
          statusEl.textContent = 'Added to your bag' + (code ? ' — code ' + code + ' will show at checkout.' : '.');
          var toggle = document.querySelector('[data-cart-toggle]');
          if (toggle) toggle.click(); // opens the theme's cart drawer and refreshes it
        }).catch(function () {
          btn.textContent = 'Try again';
          statusEl.textContent = 'Sorry, one of these items just sold out or could not be added.';
        }).then(function () {
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-duo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
